<template>
  <div class="zone-new-part-list">
    
    <!-- 品牌筛选  :class="{'sticky': isFilterBoxSticky}"-->
     <div class="filter-box" ref="filterBox">
      
       <div class="brand-filter">
         <span class="filter-label">品牌名称：</span>
         <div class="brand-options">
           <div 
             class="brand-option" 
             :class="{ active: selectedBrand === brand.name }"
             v-for="brand in brandList" 
             :key="brand.name"
             :brand="brand.name"
             @click="selectBrand(brand.name)"
           >
             <img :src="brand.logo" :alt="brand.name">
           </div>
         </div>
       </div>
       
       <!-- 时间筛选 -->
       <div class="time-filter">
         <span class="filter-label">上市时间：</span>
         <div class="time-options">
           <!-- 添加全部选项 -->
           <div 
             class="time-option" 
             :class="{ active: selectedTime === '全部' }"
             @click="selectTime({title: '全部', id: 'all'})"
           >
             全部
           </div>
           <div 
             class="time-option" 
             :class="{ active: selectedTime === month.title }"
             v-for="month in monthList"
             :key="month.id"
             @click="selectTime(month)"
           >
             {{ month.title }} 月份
           </div>
         </div>
       </div>

     </div>

    <!-- 综合排序 -->
    <!-- <div class="sort-container">
      <div class="sort-label">综合排序</div>
      <div class="sort-options">
        <el-checkbox v-model="selfBrandPriority" @change="handleSortChange">自有品牌优先</el-checkbox>
        <el-checkbox v-model="filterZeroStock" @change="handleSortChange">过滤0库存</el-checkbox>
      </div>
    </div> -->

    <!-- 商品列表 -->
    <div class="n-zone-parts-table-container">
      <!-- 添加表头 -->
      <div class="product">
        <ul class="teble-head">
          <li class="oecode">OE号
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'oecode1' }"
                @click="sortChange('oecode', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'oecode2' }"
                @click="sortChange('oecode', 2)"
              ></i>
            </div>
          </li>
          <li class="goods_name">商品名称
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'goods_name1' }"
                @click="sortChange('goods_name', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'goods_name2' }"
                @click="sortChange('goods_name', 2)"
              ></i>
            </div>
          </li>
          <li class="sccode">生产编码
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'sccode1' }"
                @click="sortChange('sccode', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'sccode2' }"
                @click="sortChange('sccode', 2)"
              ></i>
            </div>
          </li>
          <li class="oenaturebrand">配件品牌
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'oenaturebrand1' }"
                @click="sortChange('oenaturebrand', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'oenaturebrand2' }"
                @click="sortChange('oenaturebrand', 2)"
              ></i>
            </div>
          </li>
          <li class="goods_storage">库存
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'goods_storage1' }"
                @click="sortChange('goods_storage', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'goods_storage2' }"
                @click="sortChange('goods_storage', 2)"
              ></i>
            </div>
          </li>
          <li class="goods_price">订货价
            <div class="ico">
              <i
                class="el-icon-caret-top"
                :class="{ active: acSort == 'goods_price1' }"
                @click="sortChange('goods_price', 1)"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ active: acSort == 'goods_price2' }"
                @click="sortChange('goods_price', 2)"
              ></i>
            </div>
          </li>
          <li class="specification">规格</li>
          <li class="numAd">订货数量</li>
          <li class="handle-box">操作</li>
        </ul>
      </div>
      
      <!-- 替换el-table为旧配件列表样式 -->
      <div class="cargo" >
        <ul>
          <li 
            class="case-list" 
            
            v-for="(goods, childIndex) in partsList" 
            :key="childIndex" 
            @click.stop="showGoodsInfo(goods)"
          >
            <div class="details">
              <div class="isOe">
                <div class="isOe-left">
                  <div class="isOe-top">
                    <div class="name">{{ goods.oenaturebrand }}</div>
                    <div class="number">
                      {{ goods.oecode }}
                    </div>
                    <HnwCopy :data="goods.oecode"></HnwCopy>
                    <div class="tag-icon" v-if="goods.isExchange">
                      互
                    </div>
                  </div>
                  <div class="vehicleModel" v-if="goods.vehicletype">车型：{{ goods.vehicletype }}</div>
                </div>
                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }}</div>
              </div>
              

              <div class="productName" :title="goods.goods_name">
                {{ goods.goods_name }}
                <div class="product-top">
                  <img class="cx-icon" src="../../assets/common/cuxiao.png" v-if="goods.isMcx" alt="" srcset="">
                  <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                    {{goods.roiZ}} 折
                  </div>
                  <div v-if="goods.goodsPosImg" class="share-btn" @click.stop="shareGoods(goods)">
                    <img src="../../assets/common/分享.jpg" alt="" srcset="">
                  </div>
                </div>
                <div class="del-time red" v-if="goods.delivery_time">
                  预计到货: {{ goods.delivery_time}}
                </div>
              </div>

              <div class="encoding" :title="goods.sccode">
                {{ goods.sccode }}
                <HnwCopy :data="goods.sccode"></HnwCopy>
              </div>

              <div class="brand" :title="goods.oenaturebrand" :class="{'selfBrand': goods.hnw_self}">
                {{ goods.oenaturebrand }}
                <span class="hnw-self-brand" v-if="goods.hnw_self">
                  自主品牌
                </span>
              </div>

              <div class="inventory" :class="{'disabled-color':goods.goods_storage==0}">
                <template v-if="$store.state.member_id.includes('1780')">
                  <div class="goods-location">
                    <!-- is_sh=1: 上海在前，丹阳在后 -->
                    <template v-if="$store.state.is_sh == 1">
                      <div style="font-size:14px;">上海:
                        <span v-if="$store.state.look_inv==1">{{goods.sh_storage}}</span>
                        <span v-else>{{goods.sh_storage>0?"有货":"无货"}}</span>
                      </div>
                      <div style="font-size:12px;">丹阳:
                        <span v-if="$store.state.look_inv==1">{{goods.goods_stcids}}</span>
                        <span v-else>{{goods.goods_stcids>0?"有货":"无货"}}</span>
                      </div>
                    </template>
                    <!-- is_sh!=1: 丹阳在前，上海在后 -->
                    <template v-else>
                      <div style="font-size:14px;">丹阳:
                        <span v-if="$store.state.look_inv==1">{{goods.goods_stcids}}</span>
                        <span v-else>{{goods.goods_stcids>0?"有货":"无货"}}</span>
                      </div>
                      <div style="font-size:12px;">上海:
                        <span v-if="$store.state.look_inv==1">{{goods.sh_storage}}</span>
                        <span v-else>{{goods.sh_storage>0?"有货":"无货"}}</span>
                      </div>
                    </template>
                  </div>
                  <div  class="loca-btn" @click.stop="openAll(goods)"><span>货位详情</span></div>
                </template>
                <div v-else>
                  <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                  <span v-else :class="{'disabled-color':goods.goods_storage==0}">{{goods.goods_storage>0?"有货":"无货"}}</span>
                  <div class="goods-cangTip">{{goods.cangTip}}</div>
                  
                </div>
              </div>

              <div class="TheOrderPrice">
                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }} </div>
                ¥ {{ goods.goods_price }}
                <span v-if="goods.brand_ratio_price">({{goods.brand_ratio_price}})</span>
                <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                  {{goods.roiZ}} 折
                </div>
              </div>

              <div class="specification">
                {{ goods.spec }}
              </div>

              <div class="numAd" @click.stop>
                <el-input-number 
                  v-if="$store.state.zero_buy==1" 
                  v-model="goods.goods_num" 
                  :min="1" 
                  size="mini"
                ></el-input-number>
                <el-input-number 
                  v-else 
                  v-model="goods.goods_num" 
                  @change="impueNumChange(goods)" 
                  :min="1" 
                  size="mini"
                ></el-input-number>
              </div>

              <div class="handle-box">
                <div 
                  class="add-btn" 
                  :class="{'ycg-btn':goods.goods_storage==0}" 
                  @click="joinCart(goods)"
                >
                  {{goods.goods_storage>0?'加入购物车':'加入预购单'}}
                </div>
                <div class="addition">
                  <span v-if="goods.cartNum">
                    已添加 {{goods.cartNum}} 件
                  </span>
                </div>
                <el-popover
                  placement="left"
                  width="260"
                  popper-class="pop-replace-list"
                  v-model="goods.replacePopVis"
                  trigger="click"
                >
                  <div class="pop-close" @click.stop="goods.replacePopVis=false">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-table :border="false" class="replace-table" :data="buyStoreList" height="300">
                    <el-table-column width="60" type="index" label="序号"></el-table-column>
                    <el-table-column width="120" property="oecode" label="互换件号">
                      <template slot-scope="scope1">
                        <span>{{scope1.row.oecode}}</span>
                        <HnwCopy :data="scope1.row.oecode"></HnwCopy>
                      </template>
                    </el-table-column>
                    <el-table-column width="80" property="address" label="操作">
                      <template slot-scope="scope1">
                        <span class="show-btn" style="cursor: pointer" v-if="scope1.row.goods_id" @click="toSearch(scope1.row)">
                          在售
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div 
                    class="replace-btn" 
                    @click="showChangeParts(goods)" 
                    type="text" 
                    slot="reference" 
                    v-if="goods.exchange && goods.exchange.length>0"
                  >
                    查看互换件
                  </div>
                </el-popover>
              </div>
            </div>
            
            <!-- 历史购买记录 -->
            <div class="goods-ex-msg" v-if="goods.orderInfo">
              <div class="buyHis" @click.stop="readHisList(goods.goods_id)">
                您最近一次购买：
                <span>
                  {{$hnwTools.formatDateTime(goods.orderInfo.add_time,'ymd')}}
                </span>
                <span>
                  {{goods.orderInfo.goods_num?goods.orderInfo.goods_num:0}} 个
                </span>
                <span class="readMore">
                  更多
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    
    <!-- 分页控件 -->
     <!-- :page-sizes="[10, 20, 30, 50,99999]" hide-on-single-page-->
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50,99999]"
        :page-size="pageSize"
        layout="total, prev, pager, next, sizes"
        :total="totalItems">
      </el-pagination>
    </div>
    
    <!-- 货位详情弹窗 -->
    <el-dialog
      title="货位详情"
      :visible.sync="openAllotion"
      width="50%"
    >
      <div class="alltion">
        <div>OE号</div>
        <div>仓库</div>
        <div>货位</div>
        <div>库存</div>
      </div>

      <template v-if="goodsAllotion.dy.list.length>0">
        <div class="alltion">
          <div style="width: 100%;">丹阳</div>
        </div>
        <div class="alltion" v-for="(item) in goodsAllotion.dy.list" :key="item.shelfId">
          <div class="item">{{item.code}}</div>
          <div class="item">{{item.warehouseName}}</div>
          <div class="item">{{item.shelfName}}</div>
          <div class="item">{{item.shelfStockNum}}</div>
        </div>
      </template>
      <template v-if="goodsAllotion.sh.list.length>0">
        <div class="alltion">
          <div style="width: 100%;">上海</div>
        </div>
        <div class="alltion" v-for="(item) in goodsAllotion.sh.list" :key="item.shelfId">
          <div class="item">{{item.code}}</div>
          <div class="item">{{item.warehouseName}}</div>
          <div class="item">{{item.shelfName}}</div>
          <div class="item">{{item.shelfStockNum}}</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="openAllotion = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="openAllotion = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="历史购买记录" :visible.sync="hisVis" center width="800px">
        <div class="his-list">
            <div class="list-head">
                <div>购买时间</div>
                <div>发货时间</div>
                <div>购买人</div>
                <div class="col-100">价格</div>
                <div class="col-100">购买个数</div>
                <div class="col-100">发货个数</div>
                <div class="col-100">订单状态</div>
            </div>
            <div class="list-body">
                <div class="row" v-for="(his,index) in gooodsHisList" :key="index">
                    <div>{{$hnwTools.formatDateTime(his.add_time,'ymd')}}</div>
                    <div>{{$hnwTools.formatDateTime(his.delay_time,'ymd')||"无"}}</div>
                    <div>{{his.member_name}}</div>
                    <div class="col-100">{{his.goods_price}}</div>
                    <div class="col-100">{{his.goods_num}}</div>
                    <div class="col-100">{{his.send_num?his.send_num:'0'}}</div>
                    <div class="col-100">{{$hnwTools.getOrderStateText(his.order_state)}}</div>
                </div>
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>

import GoodsInfo from '../../components/GoodsInfo.vue'

export default {
  components: {
    
    GoodsInfo
  },
  data() {
    return {
      // 控制是否显示配件详情
      showGoodsDetail: false,
      selectedGoods: null,
      // 筛选条件
      selectedTime: '全部',
      selectedTimeId: 'all',
      selectedBrand: '',
      selfBrandPriority: true,
      filterZeroStock: true,
      
      // 吸附效果相关
      isFilterBoxSticky: false,
      filterBoxOffsetTop: 0,
      
      // 月份列表
      monthList: [],
      
      // 品牌列表 - 添加过滤逻辑
      brandList: [
        { name: '卢卡斯', logo: require('../../assets/common/lucasi1.png') },
        { name: 'ATI', logo: require('../../assets/common/AT1.png') },
        { name: 'HNW', logo: require('../../assets/common/HNW1.png') },
        { name: 'SCAEG', logo: require('../../assets/common/scaeg1.png') }
      ].filter(brand => {
        // 获取过滤品牌列表
        const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
        // 如果没有过滤品牌，显示所有品牌
        if (exBrands.length === 0) return true;
        
        // 检查当前品牌是否在过滤列表中
        // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
        if (brand.name === '卢卡斯') {
          return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
        }
        
        // 其他品牌直接检查是否在过滤列表中
        return !exBrands.includes(brand.name);
      }),
      
      // 商品列表
      partsList: [],
      // 互换件相关
      buyStoreList: [],
      
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      
      // 排序相关
      acSort: '',
      
      // 货位详情相关
      openAllotion: false, // 货位详情弹窗显示控制
      goodsAllotion: {
        dy: {
          title: "丹阳",
          list: []
        },
        sh: {
          title: "上海",
          list: []
        }
      },
      // 历史购买记录相关
      gooodsHisList: [],
      hisVis: false
    }
  },
  computed: {
    // 计算分页后的商品列表
    partsListPage() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.partsList.slice(start, end);
    },
    
    // 过滤后的商品列表 - 添加品牌过滤逻辑
    filteredPartsList() {
      let list = [...this.partsList]
      
      // 品牌筛选
      if (this.selectedBrand) {
        list = list.filter(item => item.oenaturebrand.includes(this.selectedBrand))
      }
      
      // 添加全局品牌过滤逻辑
      const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
      if (exBrands.length > 0) {
        list = list.filter(item => {
          // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
          if (item.oenaturebrand === '卢卡斯' || item.oenaturebrand === 'Lucas') {
            return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
          }
          // 其他品牌直接检查是否在过滤列表中
          return !exBrands.includes(item.oenaturebrand);
        });
      }
      
      // 过滤0库存
      if (this.filterZeroStock) {
        list = list.filter(item => item.goods_storage > 0 || item.goods_stcids > 0)
      }
      // 自有品牌优先
      if (this.selfBrandPriority) {
        list.sort((a, b) => {
          const isSelfBrandA = a.oenaturebrand.includes('HNW')
          const isSelfBrandB = b.oenaturebrand.includes('HNW')
          if (isSelfBrandA && !isSelfBrandB) return -1
          if (!isSelfBrandA && isSelfBrandB) return 1
          return 0
        })
      }
      
      return list
    }
  },
  methods: {
    // 显示商品详情（修改为内联组件形式）
    showGoodsInfo(goods) {
      goods.preRou = "自主专区";
      this.selectedGoods = goods;
      localStorage.setItem("hnw-web-item-data", JSON.stringify(goods));
      // 通知父组件显示商品详情
      this.$emit('showGoodsDetail', goods);
    },
    
    // 读取历史购买记录
    async readHisList(goods_id) {
      try {
        let res = await this.$api.getGoodsRecord(goods_id);
        this.gooodsHisList = res;
        this.hisVis = true;
      } catch (error) {
        console.error('获取历史购买记录失败:', error);
        this.$message.error('获取历史购买记录失败');
      }
    },
    
    // 选择时间
    selectTime(month) {
      this.selectedTime = month.title
      this.selectedTimeId = month.id
      this.currentPage = 1 // 重置页码
      this.fetchPartsList()
    },
    
    // 选择品牌
    selectBrand(brand) {
      this.selectedBrand = brand
      this.currentPage = 1 // 重置页码
      this.fetchPartsList()
    },
    
    // 处理排序变化
    handleSortChange() {
      // 排序变化时的逻辑
    },
    
    // 排序变化
    async sortChange(type, way) {
      let sort_way = way;
      let sort_type = type;
      this.acSort = sort_type + sort_way;
      this.currentPage = 1;
      this.fetchPartsList();
    },
    
    // 输入数量变化
    impueNumChange(goods) {
      if (isNaN(goods.goods_num)) {
        this.$nextTick(() => {
          this.$set(goods, "goods_num", 1);
        });
      }
      if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
        this.$nextTick(() => {
          goods.goods_num = goods.goods_storage;
        });
        return this.$store.commit("UpDateState", { invDia: true });
      }
    },
    
    // 显示货位详情
    async openAll(data) {  
      // 显示货位
      if(this.$store.state.member_id.includes('1780')){ 
        let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
        this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
      }  
      
      this.openAllotion = true
      
    },
    
    // 添加到购物车
    async joinCart(carItem) { 
      const tidySubPart = async () => {
        let carMessage = {
          goods_id: carItem.goods_id,
          sccode: carItem.sccode,
          oecode: carItem.oecode,
          goods_name: carItem.goods_name,
          goods_price: carItem.goods_price,
          goods_num: carItem.goods_num,
          goods_storage: carItem.goods_storage,
          store_id: carItem.store_id,
          store_name: carItem.store_name,
          cart_type: "1"
        };
        
        let res =  await this.$api.joinCart([carMessage]);
        //更新记录中 已添加X件 字段
        if(res){
          carItem.cartNum = Number(carItem.cartNum) + Number(carItem.goods_num);
        }
        
      };

      if (this.$isCompany()) {
        if (this.$store.state.zero_buy != 1) {
          if (carItem.goods_storage < 1) {
            // return this.$store.commit('UpDateState',{invDia:true})
          } else if (
            carItem.goods_num + Number(carItem.cartNum) >
            carItem.goods_storage
          ) {
            return this.$store.commit("UpDateState", { invDia: true });
          }
        }
        // 预购单已添加提示
        if (carItem.goods_storage < 1 && Number(carItem.cartNum) > 0) {
          // this.$affMsg("当前预购单已有该商品，是否继续添加?", tidySubPart);
          tidySubPart();
        } else {
          tidySubPart();
        }
      }
    },
    
    // 查看互换件
    async showChangeParts(epcPart) {
      try {
        this.partsList.forEach(item=>{
          item.replacePopVis = false
          item.goods_price = this.$handlePrice(item);
        })
      } catch (error) {
        console.log(error);
      }
      
      if(epcPart.exchange && epcPart.exchange.length>0){
        let oem =  epcPart.exchange.join(",")
        this.buyStoreList = []
        // let res = await this.$api.getBatchSearch({
        //   oem
        // })
        
        // if(res && res.length>0){
        //   let addStr = ''
        //   res.forEach(goods=>{
        //     if(!addStr.includes(goods.oecode)){
        //       this.buyStoreList.push({
        //         goods_id:goods.goods_id,
        //         oecode:goods.oecode
        //       })
        //       addStr += goods.oecode+",";
        //     }
        //   })
        // }
        
        epcPart.exchange.forEach(oecode=>{
          let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
          if(!has){
            this.buyStoreList.push({
              oecode
            })
          }
        })
        
        epcPart.replacePopVis = true
      }
      
      this.$message.info('查看互换件')
    },
    
    toSearch(goods){
      // this.$store.commit("UpDateState", {
      //   searchText: goods.oecode
      // });
      // this.storeVis = false
      goods.replacePopVis = false
    },
    
    // 获取月份列表
    async fetchMonthList() {
      try {
        const res = await this.$api.getDisList({
          type: 12,
          page: 1,
          limit: 999
        });
        console.log("res",res);
        
        if (res&& res.length > 0) {
          this.monthList = res;
          
          this.fetchPartsList();
        }
      } catch (error) {
        console.error('获取月份列表失败:', error);
        this.$message.error('获取月份列表失败');
      }
    },
    
    // 获取商品列表
    async fetchPartsList() {
      try {
        // 如果没有选择月份，不请求数据
        if (!this.selectedTimeId) return;
        
        const params = {
          type: 12,
          page: this.currentPage,
          limit: this.pageSize,
          id: this.selectedTimeId,
          sortK: this.selectedTimeId=='all'?'oenaturebrand':"sccode",
          sortV:"asc",
          buyer_id:this.$store.state.buyer_id
        };
        
        // 如果选择了品牌，添加品牌筛选参数
        if (this.selectedBrand) {
          params.oenaturebrand = this.selectedBrand;
          params.sortK = "sccode"
        }
        
        // 如果有排序，添加排序参数
        if (this.acSort) {
          if (this.acSort.includes('goods_storage')) {
            params.sortK = 'goods_storage';
            params.sortV = this.acSort === 'goods_storage1' ? 'asc' : 'desc';
          } else if (this.acSort.includes('goods_price')) {
            params.sortK = 'goods_price';
            params.sortV = this.acSort === 'goods_price1' ? 'asc' : 'desc';
          } else if (this.acSort.includes('oecode')) {
            params.sortK = 'oecode';
            params.sortV = this.acSort === 'oecode1' ? 'asc' : 'desc';
          } else if (this.acSort.includes('goods_name')) {
            params.sortK = 'goods_name';
            params.sortV = this.acSort === 'goods_name1' ? 'asc' : 'desc';
          } else if (this.acSort.includes('sccode')) {
            params.sortK = 'sccode';
            params.sortV = this.acSort === 'sccode1' ? 'asc' : 'desc';
          } else if (this.acSort.includes('oenaturebrand')) {
            params.sortK = 'oenaturebrand';
            params.sortV = this.acSort === 'oenaturebrand1' ? 'asc' : 'desc';
          }
        }
        
        const res = await this.$api.getDisList(params);
        console.log("res",res);
        
        if (res && res.db && res.db.length > 0) {
          // 处理商品数据
          res.db.forEach(item => {
            // 初始化商品数量
            this.$set(item, "goods_num", 1);
            // 初始化购物车数量
            this.$set(item, "cartNum", 0);
            // 初始化互换件弹窗状态
            this.$set(item, "replacePopVis", false);
            item.goods_price = this.$handlePrice(item);
          });
          
          this.partsList = res.db;
          this.totalItems = Number(res.total) || 0; // 设置总条目数
        } else {
          this.partsList = [];
          this.totalItems = 0;
        }
      } catch (error) {
        console.error('获取商品列表失败:', error);
        this.$message.error('获取商品列表失败');
        this.partsList = [];
        this.totalItems = 0;
      }
    },
    
    // 分享商品
    shareGoods(goods) {
      // 分享功能实现
      this.$message.info('分享商品')
    },
    
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 重置到第一页
      this.fetchPartsList();
    },
    
    // 处理当前页变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchPartsList();
    },
    
    // 处理滚动事件，实现吸附效果
    handleScroll() {
      // 获取筛选框距离顶部的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 当滚动距离大于等于筛选框初始位置时，启用吸附效果
      // 当滚动距离小于筛选框初始位置时，取消吸附效果
      this.isFilterBoxSticky = scrollTop >= this.filterBoxOffsetTop;
    },
    
    // 处理窗口大小调整事件
    handleResize() {
      // 重新计算筛选框位置
      this.$nextTick(() => {
        if (this.$refs.filterBox) {
          // 重新获取元素在页面中的绝对位置
          const rect = this.$refs.filterBox.getBoundingClientRect();
          this.filterBoxOffsetTop = rect.top + window.pageYOffset;
        }
      });
    }
  },
  created() {
    this.fetchMonthList();
  },
  mounted() {
    // 计算筛选框初始位置
    this.$nextTick(() => {
      if (this.$refs.filterBox) {
        // 获取元素在页面中的绝对位置
        const rect = this.$refs.filterBox.getBoundingClientRect();
        this.filterBoxOffsetTop = rect.top + window.pageYOffset;
      }
    });
    
    // 添加滚动和窗口大小调整事件监听器
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss" scoped>
.zone-new-part-list {
  padding: 10px;
  background: #fff;
  .watermark-text{
    position: absolute;
    left: 20%;
    top: 20%;
  }

  // 时间筛选样式
  .time-filter {
    margin-bottom: 10px;
    .filter-label {
      font-weight: bold;
      margin-right: 10px;
    }
    
    .time-options {
      display: inline-block;
    }
    .time-option {
      display: inline-block;
      padding: 3px 10px;
      margin-right: 5px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        border-color: #409eff;
      }
      &.active {
      // 
        // background-color: #ff9500;
        // border-color: #ff9500;
        background-color: #063376;
        border-color: #063376;
        color: #fff;
      }
    }
  }
  
  // 品牌筛选样式
  .brand-filter {
    margin-bottom: 10px;
    .filter-label {
      font-weight: bold;
      margin-right: 10px;
    }
    .brand-options {
      display: inline-block;
    }
    .brand-option {
      display: inline-block;
      padding: 3px 8px;
      margin-right: 10px;
      background-color: #fff;
      
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      text-align: center;
      img {
        // max-height: 30px;
        width: 160px;
        vertical-align: middle;
      }
      span {
        display: block;
        margin-top: 3px;
        font-size: 10px;
      }
      &:hover {
        border-color: #063376 ;
      }
      &.active {
        border-color: #063376 ;
        background-color: #063376 ;
      }
    }
  }

  // 排序样式
  .sort-container {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .sort-label {
      font-weight: bold;
      margin-right: 20px;
    }
    .sort-options {
      display: flex;
      gap: 20px;
      .el-checkbox {
        font-size: 14px;
      }
    }
  }

  // 表格样式
  .n-zone-parts-table-container {
    background-color: #fff;
    border-radius: 4px;
    padding: 5px;
    
    // 表头样式
    .product {
      height: 40px;
      background: #c4c9cc;
      .teble-head {
        display: flex;
        li {
          display: flex;
          height: 40px;
          justify-content: center;
          align-items: center;
          position: relative;
          color: #666;
          &.oecode {
            min-width: 250px;
            max-width: 250px;
          }
          &.goods_name {
            min-width: 180px;
            max-width: 180px;
          }
          &.sccode {
            min-width: 120px;
            max-width: 120px;
          }
          &.oenaturebrand {
            min-width: 120px;
            max-width: 120px;
          }
          &.goods_storage {
            width: 150px;
          }
          &.goods_price {
            width: 82px;
            position: relative;
          }
          .ico {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: 5px;
            > i {
              cursor: pointer;
              font-size: 12px;
            }
            i:hover {
              transform: scale(1.5);
              color: #3E84D6;
            }
            .el-icon-caret-top {
              position: relative;
              top: 3px;
            }
            .el-icon-caret-bottom {
              position: relative;
              top: -3px;
            }
            .active {
              color: #3E84D6;
            }
          }
          &.specification {
            width: 90px;
          }
          &.numAd {
            width: 114px;
          }
          &.handle-box {
            width: 86px;
          }
        }
      }
    }
    
    // 旧配件列表样式
    .cargo {
      display: flex;
      box-sizing: border-box;
      position: relative;
      box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
      margin-bottom: 20px;
      > ul {
        width: 100%;
      }
      .case-list {
        &.isAll {
          height: auto;
        }
      }
      .case-list:nth-child(2n) {
        background: #f7f7f7;
      }
      
      .details {
        display: flex;
        position: relative;
        .watermark-text{
          position: absolute;
          left: 20%;
          top: 20%;
        }
        >div{
          box-sizing: border-box;
        }
        .isOe {
          position: relative;
          width: 250px;
          border-right: 1px solid #e3e4ea;
          display: flex;
          justify-content: space-between;
          
          .isOe-left {
            width: 98%;
            .isOe-top {
              display: flex;
              margin-top: 14px;
              margin-bottom: 10px;
              margin-left: 10px;
              position: relative;
              .hnw-copy{
                position: absolute;
                right: 36px;
                top: -6px;
              }
              .name {
                width: 48px;
                height: 20px;
                background-color: #3E84D6;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
                color: #fff;
              }
              .number {
                cursor: pointer;
                max-width: 100px;
                margin-left: 5px;
                margin-top: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-top: 0;
                color: #333;
              }
              .tag-icon {
                display: flex;
                align-items: center;
                transform: scale(0.7);
                justify-content: center;
                width: 20px;
                height: 20px;
                background: #3E84D6;
                color: #fff;
                border-radius: 50%;
                font-size: 12px;
                position: relative;
                top: -8px;
                left: 2px;
              }
            }
            .vehicleModel {
              margin: 0 0 0 10px;
              max-width: 230px;
              box-sizing: border-box;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
              font-size: 14px;
              color: #999;
            }
          }
        }

        .productName {
          width: 180px;
          line-height: 69px;
          border-right: 1px solid #e3e4ea;
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;
          .product-top{
            position: absolute;
            right: 0px;
            top: 0px;
            display: flex;
            align-items: center;
            padding-right: 5px;
            >div{
              cursor: pointer;
            }
            .dis-good-tips-small {
              background: url(../../assets/newHome/折扣.png);
              background-size: 40px 20px;
              width: 40px;
              height: 20px;
              margin-left: 6px;
              text-align: center;
              line-height: 20px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 12px;
              color: #FFFFFF;
              z-index: 99;
            }
            .cx-icon{
              width: 22px;
              margin-left: 8px;
            }
          }
          .share-btn{
            line-height: 1;
            margin-left: 6px;
            
            img{
              width: 20px;
            }
          }
          .del-time{
            position: absolute;
            left: 20px;
            bottom: -20px;
            
          }
        }

        .encoding {
          overflow: hidden;
          width: 120px;
          line-height: 69px;
          border-right: 1px solid #e3e4ea;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;
          .hnw-copy{
              position: absolute;
              right: 20px;
              top: 8px;
          }
        }
        
        .brand {
          overflow: hidden;
          width: 120px;
          line-height: 69px;
          border-right: 1px solid #e3e4ea;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;
          .hnw-self-brand {
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
            color: #ff7519;
          }
        }
        
        // 自选品牌
        .selfBrand {
          background: #d9ecff;
          border-bottom: 1px solid #ccc;
        }
        
        .inventory {
          width: 150px;
          box-sizing: border-box;
          border-right: 1px solid #e3e4ea;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 5px 0;
          .goods-location{
            >div{
              color: #2473FF;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 3px;
            }
          }
          .loca-btn{
            cursor: pointer;
            padding: 1px;
            color: #fff;
            background: #FFAB00;
            width: 66px;
            text-align: center;
            margin: 2px auto 0;
          }
          .goods-cangTip{
            color: #F94F4C;
            font-size: 12px;
            // margin-left: 5px;
            margin-top: 2px;
            font-weight: bold;
          }
        }
        
        .TheOrderPrice {
          position: relative;
          width: 82px;
          border-right: 1px solid #e3e4ea;
          line-height: 69px;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          .watermark-text{
            right: 0px !important;
            top: -4px;
          }
          span {
            position: relative;
            top: 1px;
          }
        }

        .specification {
          overflow: hidden;
          width: 90px;
          border-right: 1px solid #e3e4ea;
          line-height: 69px;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .numAd {
          width: 114px;
          border-right: 1px solid #e3e4ea;
          line-height: 69px;
          position: relative;
          text-align: center;
          .el-input-number {
            // margin: 0 0px 0 10px;
            width: 100px;
          }
          .goods-Fcl-tit {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 2px;
            font-size: 12px;
            line-height: 12px;
            width: 120px;
            text-align: center;
            color: #999;
          }
          .red {
            color: red;
          }
        }

        .handle-box {
          position: relative;
          box-sizing: border-box;
          padding: 5px 0;
          width: 86px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .addition {
            font-size: 14px;
            color: #999;
          }
          .replace-btn {
            color: #3E84D6;
            cursor: pointer;
          }
          .add-btn {
            width: 80px;
            height: 22px;
            padding: 0;
            color: #59a8f8;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            border-radius: 0px;
            text-align: center;
            cursor: pointer;
          }
          .add-btn:active{
            transform: scale(1.1);
          }
          .ycg-btn {
            background: #f5f5f5;
            color: #999;
            border: 1px solid #dcdfe6;
          }
        }
      }
      
      .goods-ex-msg {
        display: flex;
        border-top: 1px solid #e3e4ea;
        justify-content: flex-end;
        align-items: center;
        line-height: 30px;
        height: 30px;
        .buyHis {
          cursor: pointer;
          text-align: right;
          padding: 0 5px;
          color: red;
          font-size: 12px;
          > span {
            margin-right: 10px;
            align-items: center;
          }
          .readMore {
            cursor: pointer;
          }
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0 !important;
    .his-list {
        .list-head {
            display: flex;
            height: 40px;
            align-items: center;
            background: #eeeeee;
            margin: 10px 0;
            padding: 0 8px;
            > div {
                flex: 1;
                text-align: center;
            }
            .col-100 {
                max-width: 100px;
            }
        }
        .list-body {
            .row {
                display: flex;
                padding: 0 8px;
                > div {
                    flex: 1;
                    padding: 2px 0;
                    border-bottom: 1px solid #eee;
                    flex: 1;
                    text-align: center;
                    line-height: 28px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .col-100 {
                    max-width: 100px;
                }
            }
        }
    }
}
  // 分页样式
  .pagination-container {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }

  .disabled-color{
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
}

// 配件详情覆盖层样式
.goods-info-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .goods-info-container {
    background: #fff;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    border-radius: 4px;
    
    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 2001;
      background: #f00;
      color: #fff;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
}

// 筛选框吸附样式
.filter-box.sticky {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px); // 考虑左右padding
  max-width: 1200px; // 限制最大宽度
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 100;
  background: #fff;
  padding: 10px 0;
  margin-bottom: 0;
}
</style>